module.exports = __webpack_public_path__ + "static/media/favicon.aeb0d677.ico";